import * as React from "react";
import { Box, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { usePageLayout } from "../GeneralLayout";

interface LeftDrawerProps {
  drawerContent: React.ReactNode;
  width?: number;
  topOffset?: number;
  bottomOffset?: number;
}

export default function LeftDrawer({
  drawerContent,
  width = 300,
  topOffset = 0,
  bottomOffset = 0,
}: LeftDrawerProps) {
  const theme = useTheme();
  const { openLeft, toggleLeft } = usePageLayout();
  
  return (
    <Box
      sx={{
        position: "absolute",
        top: topOffset,
        bottom: bottomOffset,
        left: 0,
        width: openLeft ? `${width}px` : "50px",
        bgcolor: theme.custom.ui.drawers.left.dark,
        color: theme.custom.base.text.primary.dark,
        transition: "width 0.3s ease",
        display: "flex",
        flexDirection: "column",
        zIndex: 5,
        boxShadow: 2,
      }}
    >
      <IconButton
        onClick={toggleLeft}
        sx={{ alignSelf: "flex-end", color: theme.custom.base.text.primary.dark }}
      >
        {openLeft ? <ChevronLeft /> : <ChevronRight />}
      </IconButton>
      {openLeft && <Box sx={{ flex: 1, p: 1, overflowY: "auto" }}>{drawerContent}</Box>}
    </Box>
  );
}
